type DecicionWhenType = boolean;

type DecisionthenType<T> = () => T;

type DecisionType<T> = {
    when: DecicionWhenType[];
    then: DecisionthenType<T>;
};

export const decide = <T>(decisions: DecisionType<T>[]): T | null => {
    for (const decision of decisions) {
        if (decision.when.every(Boolean)) {
            return decision.then();
        }
    }

    return null;
};
